export function getBuildInfo(state) {
  return state.build;
}